module.exports = __webpack_public_path__ + "img/only-silvers.e0dbef01.png";